var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _path5, _rect, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopMobileTabletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Desktop",
    d: "M324.94,410.87l-143.9.08c-3.26,0-6.73-1.83-6.72-5.35l.07-19.7c.01-3.23,3.35-5.07,6.16-5.07l24.83.02.68-3.89,2.82-14.14-123.91-.04c-10.2-1.28-17.63-8.75-18.98-18.9l.02-227.01c1.51-9.71,8.58-16.8,18.22-18.6h335.98c10.07,1.6,17.71,9.42,18.56,19.59l-.02,226.33c-1.62,10.02-8.88,17.29-18.98,18.59l-123.93.04,3.48,18.03h25.23c3.02.14,5.93,2.45,5.92,5.64l-.06,19.19c0,2.35-2.55,5.18-5.46,5.19ZM426.69,119.01c0-4.62-3.69-7.82-8.03-8.69H86.74c-4.5.33-7.54,3.34-8.72,7.67v196.71s348.7-.03,348.7-.03l-.04-195.66ZM283.65,362.83l-62.61.02-3.36,18.03,69.41-.07-3.44-17.99ZM186.22,392.9v6.02s132.29-.01,132.29-.01v-6.02s-132.29.01-132.29.01ZM426.74,342.53l-.06-15.77H78.05s-.05,15.88-.05,15.88c.5,3.6,3.64,8.12,7.96,8.12l332.88.04c4.46-.83,7.4-4.11,7.89-8.28ZM264.39,338.25c-.29-3.07-2.72-5.51-6-5.51h-12.06c-2.42,0-4.64,1.62-5.44,3.45-1.03,2.36-.71,4.8.97,6.79.86,1.02,2.67,1.76,4.16,1.75l13.22-.1c3.47-.03,5.42-3.52,5.15-6.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M501.97,245.28c5.35.95,10.24,5.51,10.24,10.82l.03,155.95c0,5.73-4.67,10.58-10.27,11.34h-126.62c-5.24-.87-10.08-5.47-10.08-10.98v-156.13c.01-5.76,4.97-10.04,10.44-10.99h126.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.28,257.7c4.45.81,8.51,4.74,8.51,9.31l.02,134.19c0,4.93-3.88,9.1-8.54,9.76h-105.21c-4.35-.75-8.38-4.7-8.38-9.45v-134.34c0-4.95,4.13-8.64,8.68-9.46h104.91Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M493.96,397.28v-125.78c0-3.4-2.69-6.84-6.3-6.84h-97.67c-3.45,0-6.45,3.16-6.45,6.56v126.35c0,3.21,3.04,6.46,6.55,6.47l96.85.02c1.97,0,3.62-.59,4.98-1.95s2.04-2.9,2.04-4.82Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.75,
    cy: 397.57,
    rx: 4.71,
    ry: 4.69
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.76,
    cy: 271.11,
    rx: 2.76,
    ry: 2.74
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M487.48,391.08h-97.43c-.72-.14-1.38-.58-1.38-1.39v-110.8c0-.87.84-1.3,1.62-1.3h97.2c.61,0,1.35.54,1.35,1.17v111.07c-.17.7-.56,1.08-1.35,1.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 393.29,
    y: 283.2,
    width: 90.92,
    height: 101.97
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99.28,423.38H33.32c-2.38,0-4.44-.4-6.47-1.26-6.13-2.34-9.98-7.39-10.59-13.43l-.08-117.98c0-9.02,7.63-16.43,17.81-16.43h64.47c9.2.2,16.7,6.56,17.32,14.83v119.82c-.81,7.83-7.66,14.04-16.5,14.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M90.97,410.95h-49.5c-1.78,0-3.33-.33-4.85-1.05-4.6-1.95-7.49-6.16-7.95-11.19l-.06-98.32c0-7.52,5.73-13.69,13.37-13.69h48.38c6.9.16,12.53,5.47,13,12.36v99.85c-.61,6.53-5.75,11.7-12.38,12.05Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.17,297.62v-2.77s-26.3,0-26.3,0l-.03,2.58c-.02,1.34.93,2.31,2.25,2.31l22.18-.03c1.16,0,1.9-1.1,1.91-2.1Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M83.39,298.1c-.3,3.12-2.68,6-5.89,6l-22.87.04c-2.99,0-5.95-3-6-6.38l-.04-2.93-5.28.06c-3.82.32-6.77,3.84-6.77,7.87l.03,92.42c0,3.97,3.18,7.58,6.99,7.59l43.97.1c4.31,0,7.93-3.2,7.93-7.85v-92.97c-.46-3.98-3.36-7.16-7.18-7.18l-4.86-.03-.04,3.26Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M82.69,397.55c0-1.17-.91-2.38-2.3-2.38h-28.47c-1.43,0-2.47.95-2.55,2.21-.08,1.18.8,2.51,2.23,2.51h28.72c1.51,0,2.38-1.12,2.37-2.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMobileTabletIcon);
export default __webpack_public_path__ + "static/media/desktopMobileTabletIcon.75ab00dbe64d5893f00439e007040463.svg";
export { ForwardRef as ReactComponent };